import React from "react";
import Axios from "axios";
import { init } from "@src/utils/logClient";
import { APIDomain } from "@src/utils/APIDomain";

type MobileData = {
  user?: { _id: string; username: string; type: "student" | "parent" | "teacher" };
};
export type MobileDataContextProps = { data: MobileData; set: (arg0: MobileData) => void };

const defaultContextValue = {
  data: { user: undefined },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set: () => {},
};

const MobileDataContext = React.createContext<MobileDataContextProps>(defaultContextValue);

class MobileDataContextProvider extends React.Component<Record<string, unknown>, MobileDataContextProps> {
  constructor(props: Record<string, unknown>) {
    super(props);

    this.setData = this.setData.bind(this);
    this.state = {
      ...defaultContextValue,
      set: this.setData,
    };
  }

  componentDidMount() {
    if (process.env.GATSBY_ENV === "development") {
      init({
        site: "lite",
        env: "dev",
        customEndpoint: "/logs",
        productArea: "external",
      });
    } else {
      init({
        site: "lite",
        env: "prod",
        customEndpoint: "/logs",
        buildNumber: `${process.env.GATSBY_BUILD_NUMBER}-${process.env.GATSBY_GIT_COMMIT}`,
        productArea: "external",
      });
    }

    this.getSession();
  }

  getSession() {
    const SESSION = `${APIDomain}/api/session`;
    Axios.get(SESSION, { withCredentials: true })
      .then((response) => {
        const data: MobileData = { user: response.data };
        this.setData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setData(newData: MobileData) {
    this.setState((state: MobileDataContextProps) => ({
      data: {
        ...state.data,
        ...newData,
      },
    }));
  }

  render() {
    return <MobileDataContext.Provider value={this.state}>{this.props.children}</MobileDataContext.Provider>;
  }
}

export { MobileDataContext, MobileDataContextProvider };
